import React, { Component, ReactNode } from 'react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Platform } from 'sofa-reborn-react';
import { IDexfSettings, ITranslations } from '@inter-ikea-kompis/types';
import styled from 'styled-components';
import { KompisCountdownBanner } from '@inter-ikea-kompis/react-components';

const BannerContainer = styled.div`
	position: absolute;
	top: 0;
	z-index: 1000;
`;

type Props = {
	platform: Platform;
	kompisSettings?: IDexfSettings | null;
	kompisTranslations?: ITranslations | null;
	timeoutWarningVisible: boolean;
	startTime: number;
	time: number;
	showIpexGalleryButton: boolean;
	onClose?: () => void;
	onSessionClick?: () => void;
	onTimeEnd?: () => void;
	onTimeChange?: (e: CustomEvent) => void;
};

/**
 * React component.
 *
 */
export default class TimeoutWarning extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onClose, onSessionClick, onTimeEnd, onTimeChange } = props;
		if (props.kompisSettings && props.kompisTranslations) {
			return (
				<BannerContainer>
					<KompisCountdownBanner
						theme={SkapaTheme}
						translations={props.kompisTranslations.kompis}
						startTime={props.startTime}
						time={props.time}
						visible={props.timeoutWarningVisible}
						showSecondaryButton={props.showIpexGalleryButton}
						onClose={(): void => onClose && onClose()}
						onSessionClick={(): void => onSessionClick && onSessionClick()}
						onTimeEnd={(): void => onTimeEnd && onTimeEnd()}
						onTimeChange={(e: CustomEvent): void => onTimeChange && onTimeChange(e)}
					></KompisCountdownBanner>
				</BannerContainer>
			);
		}
		return null;
	}
}
